import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

interface CreateOrJoinModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateNew: () => void;
  onJoinExisting: () => void;
}

export const CreateOrJoinModal: React.FC<CreateOrJoinModalProps> = ({
  isOpen,
  onClose,
  onCreateNew,
  onJoinExisting,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="640px" borderRadius="2xl">
        <ModalCloseButton />
        <ModalHeader pt="6">
          <Text fontSize="lg" fontWeight="semibold">
            Corporate Organization
          </Text>
          <Text fontSize="sm" color="gray.600" fontWeight="normal" mt="2">
            Would you like to create a new organization or join an existing one?
          </Text>
        </ModalHeader>
        <ModalBody pb="6" pt="4">
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4" mt="4">
            <Button
              type="button"
              onClick={onCreateNew}
              w="100%"
              minH="180px"
              borderWidth="1px"
              borderColor="gray.200"
              borderRadius="2xl"
              bg="white"
              textAlign="left"
              p="6"
              cursor="pointer"
              transition="all 0.2s"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              alignItems="stretch"
              _hover={{ bg: 'blue.50', shadow: 'md' }}
              _focus={{ boxShadow: 'outline' }}
              variant="unstyled"
            >
              <Stack spacing="3" align="flex-start" h="full" justify="space-between">
                <Box>
                  <Text fontWeight="semibold" fontSize="lg" mb="2">
                    Create New Organization
                  </Text>
                  <Text
                    fontSize="sm"
                    color="gray.600"
                    lineHeight="tall"
                    whiteSpace="normal"
                    overflowWrap="break-word"
                  >
                    Set up a new organization and add team members.
                  </Text>
                </Box>
              </Stack>
            </Button>

            <Button
              type="button"
              onClick={onJoinExisting}
              w="100%"
              minH="180px"
              borderWidth="1px"
              borderColor="gray.200"
              borderRadius="2xl"
              bg="white"
              textAlign="left"
              p="6"
              cursor="pointer"
              transition="all 0.2s"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              alignItems="stretch"
              _hover={{ bg: 'blue.50', shadow: 'md' }}
              _focus={{ boxShadow: 'outline' }}
              variant="unstyled"
            >
              <Stack spacing="3" align="flex-start" h="full" justify="space-between">
                <Box>
                  <Text fontWeight="semibold" fontSize="lg" mb="2">
                    Join Existing Organization
                  </Text>
                  <Text
                    fontSize="sm"
                    color="gray.600"
                    lineHeight="tall"
                    whiteSpace="normal"
                    overflowWrap="break-word"
                  >
                    Request access to your company&apos;s existing membership.
                  </Text>
                </Box>
              </Stack>
            </Button>
          </SimpleGrid>

          <Button
            size="lg"
            variant="ghost"
            onClick={onClose}
            width="fit-content"
            mt="4"
            px="1"
            color="blue.600"
            _hover={{ bg: 'transparent' }}
          >
            Back
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
